(function() {
  define('tlhFiltersFilesize',['angular'], function() {
    'use strict';
    return angular.module('tlhFiltersFilesize', []).filter('filesize', function() {
      return function(bytes) {
        var unit;
        if (bytes > 0 && bytes < 1000) {
          unit = 'octets';
        } else if (bytes >= 1000 && bytes < 1000000) {
          bytes /= 1000;
          unit = 'Ko';
        } else if (bytes >= 1000000 && bytes < 1000000000) {
          bytes /= 1000000;
          unit = 'Mo';
        } else if (bytes >= 1000000000) {
          bytes /= 1000000000;
          unit = 'Go';
        } else if (bytes >= 1000000000000) {
          bytes /= 1000000000000;
          unit = 'To';
        }
        return Math.round(bytes) + ' ' + unit;
      };
    });
  });

}).call(this);

//# sourceMappingURL=filesize.js.map
;
